import $ from 'jquery';

class UserFormValuesExtractor {
    getMeals(mealsCount) {
        if (mealsCount === 3) {
            return [true, false, true, false, true, false];
        } else if (mealsCount === 4) {
            return [true, true, true, false, true, false];
        } else if (mealsCount === 5) {
            return [true, true, true, true, true, false];
        } else if (mealsCount === 6) {
            return [true, true, true, true, true, true];
        }
    }

    isFieldExists(selector) {
        return $(selector).length;
    }

    getInt(selector) {
        return parseInt(this.getValue(selector));
    }

    getFloat(selector) {
        return parseFloat(this.getValue(selector));
    }

    getString(selector) {
        return this.getValue(selector).trim();
    }

    getValue(selector) {
        return $(selector).val();
    }

    // modifies argument
    addInt(params, field, selector) {
        if (this.isFieldExists(selector)) {
            params[field] = this.getInt(selector);
        }
    }

    // modifies argument
    addFloat(params, field, selector) {
        if (this.isFieldExists(selector)) {
            params[field] = this.getFloat(selector);
        }
    }

    // modifies argument
    addString(params, field, selector) {
        if (this.isFieldExists(selector)) {
            const value = this.getString(selector);
            if (value) {
                params[field] = value;
            }
        }
    }

    // modifies argument
    addValue(params, field, selector) {
        if (this.isFieldExists(selector)) {
            params[field] = this.getValue(selector);
        }
    }

    extractUserRegistrationParams() {
        const params = {
            ...this.extractUserParams(),
        };
        this.addString(params, 'inviterCode', '#inviterCode');
        // Признак партнёрской регистрации: его ставит страница
        // `/partner/<код>`. Вместе с кодом он даёт роль эксперта
        // и привязку к владельцу кода.
        this.addString(params, 'asPartner', '#asPartner');
        this.addString(params, 'email', '#email');
        this.addInt(params, 'height', '#height');
        this.addInt(params, 'birthYear', '#birthYear');
        this.addInt(params, 'sex', 'input[name="sex"]:checked');
        return params;
    }

    extractUserParams() {
        const params = {};
        if (this.isFieldExists('#meals-count')) {
            params.meals = this.getMeals(this.getInt('#meals-count'));
        }
        this.addString(params, 'name', '#name');
        this.addString(params, 'surname', '#surname');
        this.addString(params, 'phone', '#phone');
        this.addInt(params, 'programmsUpdatePeriod', '#programms-update-period');
        // Рост в личном кабинете только для чтения — не отправляем.
        if (!$('#height').prop('disabled')) this.addInt(params, 'height', '#height');
        this.addInt(params, 'weight', '#weight');
        this.addFloat(params, 'activityCoefficient', '#activityCoefficient');
        this.addInt(params, 'maxRecipeDifficulty', '#maxRecipeDifficulty');
        this.addInt(params, 'maxRecipePrice', '#maxRecipePrice');
        // Цель теперь одна и передаётся кодом справочника. Старый массив
        // goals с фронта больше не приходит: на нём держится подбор
        // тренировок, и заполняет его миграция, а не анкета.
        // Анкета активности: код вопроса -> код ответа. Скрытые зависимые
        // вопросы не отправляем.
        const activity = {};
        $('.activity-question').each(function () {
            const $question = $(this);
            if ($question.is(':hidden')) return;
            const code = $question.attr('data-question');
            const value = $question.find('.activity-answer').val();
            if (code && value) activity[code] = value;
        });
        if (Object.keys(activity).length) params.activity = activity;
        this.addValue(params, 'goalCode', '#goalCode');
        this.addValue(params, 'dietTypeCode', '#dietTypeCode');
        this.addInt(params, 'level', '#level');
        this.addValue(params, 'equipment', '#equipment');
        this.addValue(params, 'contraindications', '#contraindications');
        // Чего нет на кухне. Поле в форме было, а в отправке его
        // не было вовсе: выбор просто пропадал при сохранении
        // (разбор 12.10). Множественный селект отдаёт массив.
        this.addValue(params, 'disallowedKitchenware', '#disallowedKitchenware');
        return params;
    } 
}

export {
    UserFormValuesExtractor
};
